<template>
    <div class="upload">
        <div class="upload-avater">
            <img :src="url" alt v-if="url" />
            <div @click.prevent="onSelectUpload()">
                <img class="avatar" :src="avatar" alt />
                <!-- <input class="avatar-input" type="file" accept="image/*" capture="camera" @change="setImg" /> -->
            </div>
        </div>
        <div class="cropper-compontent" v-if="isCroper">
            <div class="cropper-wrapper">
                <vueCropper ref="cropper" class="cropper" :img="img" :canMoveBox="false" :can-scale="true" :can-move="true" :auto-crop="true" :fixed-box="true" enlarge="1" :output-size="option.size"
                            :output-type="option.outputType" :center-box="option.centerBox" :fixedNumber="[1, 2]" :auto-crop-width="width" :auto-crop-height="height"></vueCropper>
            </div>

            <div class="modify-img">
                <van-button type="primary" size="small" color @click.prevent="isCroper = false">返回</van-button>
                <van-button type="primary" size="small" plain color @click.prevent="OnRotateLeft()">左旋</van-button>
                <van-button type="primary" size="small" plain color @click.prevent="OnRotateRight()">右旋</van-button>
                <van-button type="primary" size="small" color @click.prevent="saveImg()">确定</van-button>
            </div>
        </div>
        <input class="avatar-input" type="file" accept="image/*" ref="camera" capture="camera" @change="setImg" />
        <input class="avatar-input" type="file" accept="image/*" ref="files" @change="setImg" />
        <!-- <van-action-sheet
      v-model="showUploadType"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      @cancel="onCancel"
      @select="onSelect"
    /> -->

        <van-popup v-model="showUploadType" position="bottom">
            <div class="upload-before">
                <div class="example-img">
                    <img :src="example" alt="">
                </div>
                <div class="action">
                    <div class="action-btn" @click="onSelect('拍照')">拍照</div>
                    <div class="action-btn" @click="onSelect('文件')">从相册上传</div>
                    <div class="action-btn" @click="showUploadType = false">取消</div>
                </div>

            </div>

        </van-popup>
    </div>
</template>

<script>
import httpRequest from '@/api/http.js';
import Toast from 'vant/lib/toast';
export default {
    props: {
        imgUrl: {
            type: String,
        },

        width: {
            type: String,
            default: '250',
        },
        height: {
            type: String,
            default: '350',
        },
    },
    data() {
        return {
            showUploadType: false,
            file: null,
            isCroper: false,
            url: '',
            filesType: '',
            example: require('../../assets/img/example.png'),
            avatar: require('../../assets/img/upload.png'),
            actions: [{ name: '拍照' }, { name: '文件' }],
            option: {
                size: 0,
                centerBox: false,
                outputType: 'jpg',
                autoCropWidth: '250',
                autoCropHeight: '350',
            },
        };
    },
    watch: {
        imgUrl() {
            this.url = this.imgUrl;
        },
    },
    components: {},
    methods: {
        // 上传图片
        handleUploadImg(file) {
            let formData = new FormData();
            formData.append('file', file);

            Toast.loading({
                message: '上传中...',
                forbidClick: true,
                loadingType: 'spinner',
            });

            httpRequest
                .post(`/api/visitor/upload`, formData, true)
                .then(res => {
                    if (res.data.code == 200) {
                        this.url = res.data.data.url;
                        this.isCroper = false;
                        this.$emit('OnUploadImg', res.data.data.url);
                    }
                })
                .catch(error => {})
                .finally(() => {
                    Toast.clear();
                });
        },

        //坐旋转
        OnRotateLeft() {
            this.$refs.cropper.rotateLeft();
        },
        //右旋转
        OnRotateRight() {
            this.$refs.cropper.rotateRight();
        },

        setImg(e) {
            let files = e.target.files || e.dataTransfer.files;
            this.file = files[0];

            if (/^image/.test(files[0].type)) {
                // 创建一个reader
                let reader = new FileReader();
                reader.readAsDataURL(files[0]);
                reader.onload = () => {
                    let result = reader.result;
                    this.img = result;
                    this.isCroper = true;
                };
            }
        },
        saveImg() {
            this.$refs.cropper.getCropBlob(data => {
                let files = new window.File([data], this.file.name, {
                    type: this.file.type,
                });

                console.log('files', files);

                this.handleUploadImg(files);
            });
        },
        onSelectUpload() {
            this.showUploadType = true;
        },
        onSelect(value) {
            this.showUploadType = false;
            this.filesType = value;
            if (value == '拍照') {
                this.$refs.camera.click();
            } else if (value == '文件') {
                this.$refs.files.click();
            }
        },
        onCancel() {
            this.showUploadType = false;
        },
    },
    created() {},
    mounted() {},
};
</script>

<style lang="scss" scoped>
.upload {
    position: relative;

    .upload-avater {
        display: flex;

        img {
            height: 70px;
            margin-right: 10px;
            border-radius: 10px;
        }
        div {
            .avatar {
            }
        }

        .avatar-input {
            opacity: 0;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
    }
    .cropper-compontent {
        .cropper-wrapper {
            .cropper {
            }
        }
        .modify-img {
        }
    }
    .avatar-input {
    }
    ::v-deep .van-popup {
        background: none;
    }
    .upload-before {
        display: flex;

        flex-direction: column;
        padding: 12px;
        .example-img {
            img {
                width: 100%;
            }
        }
        .action {
            background: #fff;
            border-radius: 10px;
            .action-btn {
                height: 50px;
                line-height: 50px;
                padding: 0 16px;
                text-align: center;
                border-bottom: 1px solid #eaeaea;
            }
            .action-btn:nth-of-type(3) {
                border-bottom: none;
            }
        }
    }
}

.avatar-input {
    display: none;
    opacity: 0;
    position: absolute;
    left: 0;
    top: 0;
    width: 70px;
    height: 70px;
}

.cropper-compontent {
    position: fixed;
    z-index: 99;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background: #fff;

    .cropper-wrapper {
        height: calc(100% - 120px);
    }

    .modify-img {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px;
    }
}
</style> 